import React from 'react';
import Button from '~/components/button';
import { useContentLibrary } from '../../../providers/content_library_provider';
const ClearSelectedDocumentsButton = () => {
    const { clearSelectedDocuments } = useContentLibrary();
    return React.createElement("div", { className: 'buttons-container' },
        React.createElement(Button, { "data-testid": 'clear-selected-documents-button', secondary: true, className: 'selected-documents-button clear', onClick: clearSelectedDocuments, id: 'clear-documents-button' },
            React.createElement("span", null,
                React.createElement("i", { className: 'far fa-trash-alt' })),
            React.createElement("span", { className: 'clear-text' }, "Clear")));
};
export default ClearSelectedDocumentsButton;
